export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.22-1345.19",
  commitId: "35f8e4f4369a61d2cd12f1ec08bb2b37e643604d",
  commitTime: "2026-05-22T13:45:19.000Z",
});
